import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDjangoComponent } from './simple-icons-django.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDjangoComponent ],
    exports:      [ SimpleIconsDjangoComponent ],
    bootstrap:    []
})
export class SimpleIconsDjangoModule {}
